import { LICENCE_CHECK } from 'constants/actionTypes';

export const licenseReducer = (state = false, action) => {
    switch(action.type) {
        case LICENCE_CHECK:
            return action.payload;
        default:
            return state;
    }
};
